module.exports = __webpack_public_path__ + "static/Museo_Slab_700-webfont-6f72ef3e43f9385eead0c26d5fee2ee0.woff2";